import { UserRole } from '@my-roadtrip/types'

/**
 * Checks if a value is a valid UserRole.
 */
export const isValidUserRole = (role: unknown): role is UserRole => {
    return typeof role === 'string' && ['user', 'moderator', 'admin', 'superadmin'].includes(role)
}

/**
 * Checks if a role has admin privileges (admin or superadmin).
 */
export const isAdminRole = (role: unknown): boolean => {
    return isValidUserRole(role) && (role === 'admin' || role === 'superadmin')
}

/**
 * Checks if a value is a string.
 */
export const isString = (value: unknown): value is string => {
    return typeof value === 'string'
}

/**
 * Checks if a value is a non-empty string.
 */
export const isNonEmptyString = (value: unknown): value is string => {
    return typeof value === 'string' && value.trim().length > 0
}
